import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";

import { AjsResponse, wrapAjs } from "../ajs-response";

/**
 * HouseholdApiService (Angular 18) — single-endpoint household detail lookup.
 *
 * Replaces apps/b2b-ui/common/services/api/householdApi/householdApi.service.js.
 *
 * The legacy service set its base via `init(endpoint)` to `endpoint + '/household'`
 * and then mutated `/v1/` to `/v2/` per call. We just hardcode the v2 URL.
 */
const HOUSEHOLD_BASE_V2 = "/v2/api/household";

@Injectable({ providedIn: "root" })
export class HouseholdApiService {
  private readonly http = inject(HttpClient);

  detail(householdId: number | string): Promise<AjsResponse<unknown>> {
    return wrapAjs(
      this.http.get<unknown>(`${HOUSEHOLD_BASE_V2}/${householdId}`),
    );
  }
}
